import type { DatePickerProps } from 'antd';
import { DatePicker } from 'antd';
import type { Dayjs } from 'dayjs';
import { DATE_PICKER_FILTER } from '@features/regional-overview/domain/tests-id.constants';
import { getYesterdayCalendarDate } from '@features/regional-overview/utils/current-calendar-date.utils';

interface DatePickerFilterProps {
  onChange: (value: Dayjs) => void;
  selectedValue: Dayjs;
  blockFutureDates?: boolean;
}

export const DatePickerFilter = ({ onChange, selectedValue, blockFutureDates }: DatePickerFilterProps) => {
  const yesterday = getYesterdayCalendarDate();

  const handleOnChange: DatePickerProps['onChange'] = date => {
    if (!date) {
      return;
    }

    onChange(date);
  };

  return (
    <DatePicker
      size='large'
      onChange={handleOnChange}
      value={selectedValue}
      allowClear={false}
      data-testid={DATE_PICKER_FILTER}
      maxDate={blockFutureDates ? yesterday : undefined}
    />
  );
};
